import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { getUserProfileUrl } from "../../../utils/camp.utils";
import Blue_Badge from '../../../assets/icon/Verified-badge.svg';
import Cross_Badge from '../../../assets/icon/Unverified.svg';
import { Button, Image, Spinner } from "react-bootstrap";
import { CAMP_INSIGHTS, CAPTAIN_NOTES } from "../../../constants/routes.constants";
import RoundButton from "../../common/RoundButton";
import WriteNotesModal from "./WriteNotesModal";
import { notesViewModel } from "./notes.view.model";
import { useAuth } from "../../auth/Auth";
import CampRestrictModal from "./CampRestrictModal";
import "./css/kid.section.css";
import CampRequestDropdown from "./camp_invite/CampRequestDropdown";
import { schoolViewModel } from "./school.view.model";
import { settingsViewModel } from "../dashboard/settings.view.model";
import CampRequestSelectBox from "./CampRequestSelectBox";

const KidsSectionTable = ({ kid, list, setList }) => {
    const history = useHistory();
    const [count, setCount] = useState(0);
    const [showWriteNoteModal, setShowWriteNoteModal] = useState(false);
    const [showRestrictCampModal, setShowRestrictCampModal] = useState(false);
    const [selectedDependent, setSelectedDependent] = useState(null);
    const { school } = useAuth();
    const [connectionLoading, setConnectionLoading] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

    const checkNoteAvailable = async () => {
        const data = {
            dependent_id: kid?.id,
            group_id: kid?.profile?.group?.id
        }

        try {
            const res = await notesViewModel.getNotes(data)
            if (res.length !== 0) {
                setCount(res.length)
            } else {
                setCount(0)
            }
        } catch (error) {
            console.log(error)
            setCount(0)
        }
    }

    const handleWriteNoteClick = () => {
        if (school?.subcription_type !== "premium") {
            setShowRestrictCampModal(true);
            return;
        }
        setSelectedDependent(kid)
        setShowWriteNoteModal(true)
    }

    const handleOpenNotes = () => {
        history.push({
            pathname: CAPTAIN_NOTES,
            state: {
                kid: JSON.stringify(kid)
            }
        })
    }

    const handleKidClick = (kid) => {
        if (school?.subcription_type !== "premium") {
            setShowRestrictCampModal(true);
            return;
        } else {
            history.push({
                pathname: CAMP_INSIGHTS,
                state: {
                    dependent: kid?.username
                }
            })
        }
    }

    const handleStatusChange = (status) => {
        setConnectionLoading(true);
        schoolViewModel.changeConnectionStatus(status, kid?.id).then((res) => {
            if (status === "accept") kid.profile.tribe_request_status = "accept";
            if (status === "decline") {
                kid.profile.tribe_request_status = "decline";
                disConnectTreehouse();
            }
            setConnectionLoading(false);
        }).catch((err) => {
            console.log(err);
        })
    }

    const handleDelete = () => {
        handleStatusChange("decline")
    }

    const disConnectTreehouse = () => {
        let params = {
            dependent_id: kid?.id,
            treehouse_id: kid?.profile?.group.id
        }
        settingsViewModel.disConnectTreehouse(params).then((res) => {
            setList(list.filter(obj => obj.id !== kid?.id))
            setShowDeleteConfirm(false);
        }).catch((err) => {
            console.log(err)
        })
    }

    return (
      <React.Fragment id="captain-step-mycamp">
        <CampRestrictModal
          showModal={showRestrictCampModal}
          setShowModal={setShowRestrictCampModal}
        />
        <WriteNotesModal
          type="new"
          selectedDependent={kid}
          showModal={showWriteNoteModal}
          setShowModal={setShowWriteNoteModal}
          getNotes={checkNoteAvailable}
        />
        <tr>
          <td>
            <div
              className="kids_name_img add-pointer"
              onClick={() => history.push(`/${kid?.username}`)}
            >
              <Image
                className="KidsAvtar"
                src={
                  kid.profile.picture_url
                    ? kid.profile.picture_url
                    : getUserProfileUrl(kid)
                }
              />
              {kid?.profile?.tribe_request_status === 'invited_by_camp'
                ? 'Invited'
                : kid.username}
              <Image
                className="blue_badge"
                src={kid.profile.is_activated ? Blue_Badge : Cross_Badge}
              />
            </div>
          </td>
          <td>{kid?.profile?.group?.name}</td>
          <td>
            {kid.guardian.first_name} {kid.guardian.last_name}
          </td>
          <td>
            {kid?.special_camp?.attend === 'YES'
              ? 'Attending'
              : kid?.special_camp?.attend === 'NO'
              ? 'Not attending'
              : ''}{' '}
            {kid?.special_camp?.name
              ? kid?.special_camp?.special_camp_count - 1 === 0
                ? `(${kid?.special_camp.name})`
                : `(${kid?.special_camp.name}) +${kid?.special_camp?.special_camp_count - 1}`
              : '-'}
          </td>
          <td className="wrap-email">
            <a href={`mailto:${kid.guardian.email}`}>{kid.guardian.email}</a>
          </td>

          <td
            style={{
              position:
                kid?.profile?.tribe_request_status === 'requested_by_guardian'
                  ? 'sticky'
                  : '',
            }}
            id="captain-step-moredetails"
          >
            {connectionLoading ? (
              <Spinner
                key={0}
                className="home-feed-spinner"
                animation="border"
                variant="info"
              />
            ) : kid?.profile?.tribe_request_status ===
              'requested_by_guardian' ? (
              // <CampRequestDropdown
              //     handleStatusChange={handleStatusChange}
              //     handleDelete={handleDelete}
              //     showDeleteConfirm={showDeleteConfirm}
              //     setShowDeleteConfirm={setShowDeleteConfirm}
              // />
              <CampRequestSelectBox
                handleStatusChange={handleStatusChange}
                handleDelete={handleDelete}
                showDeleteConfirm={showDeleteConfirm}
                setShowDeleteConfirm={setShowDeleteConfirm}
              />
            ) : kid?.profile?.tribe_request_status === 'decline' ? (
              <RoundButton
                type="button"
                label={`Declined`}
                className="transparent-button d-sm-block open-notes-btn kid-section-notes-btn more-details-btn"
                disabled={kid?.profile?.tribe_request_status !== 'accept'}
              />
            ) : (
              <RoundButton
                type="button"
                label={`More Details`}
                className="transparent-button d-sm-block open-notes-btn kid-section-notes-btn more-details-btn"
                onClick={() => handleKidClick(kid)}
                disabled={kid?.profile?.tribe_request_status !== 'accept'}
              />
            )}
          </td>
        </tr>
      </React.Fragment>
    );
}

export default KidsSectionTable;